module.exports = __webpack_public_path__ + "6faf90f111fae9676c8c53a59f8b28b8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/player_card.png
 ** module id = 1073
 ** module chunks = 0
 **/